var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 13,
    viewBox: "0 0 7 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.24019 0.45C3.35566 0.25 3.64434 0.25 3.75981 0.45L6.27128 4.8C6.38675 5 6.24241 5.25 6.01147 5.25H0.988526C0.757586 5.25 0.613249 5 0.728719 4.8L3.24019 0.45Z",
    fill: "#D0D1D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.24019 12.55C3.35566 12.75 3.64434 12.75 3.75981 12.55L6.27128 8.2C6.38675 8 6.24241 7.75 6.01147 7.75H0.988526C0.757586 7.75 0.613249 8 0.728719 8.2L3.24019 12.55Z",
    fill: "#616568"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortingIcon);
export default __webpack_public_path__ + "static/media/sorting-icon.7cff0b54d2027f857c25327741edb6c2.svg";
export { ForwardRef as ReactComponent };